import CardConsumptAudit from './src/main';

/* istanbul ignore next */
CardConsumptAudit.install = function(Vue) {
  Vue.component(CardConsumptAudit.name, CardConsumptAudit);
};

export default CardConsumptAudit;
